import API from "helpers/api";
import { Apis } from "services/api";
import { getAPIResponse } from "helpers/getApiResponse";
import { defaultPageSize } from "helpers/utils";
import { processChipsForAPI } from "helpers/chipProcessor";

export const getDefectsList = async ({
	siteAppId,
	pageNumber = "1",
	pageSize = defaultPageSize(),
	search = "",
	sortField = "",
	sortOrder = "",
	fromDate = "",
	toDate = "",
	chips = [],
	onlySAPErrors = false,
	onlyFLOC = false,
}) => {
	try {
		// Process chips into individual arrays using centralized utility function
		const chipsByType = processChipsForAPI(chips);

		const payload = {
			siteAppId,
			pageNumber,
			pageSize,
			search,
			sortField,
			sortOrder,
			fromDate,
			toDate,
			onlySAPErrors,
			onlyFLOC,
			// Individual arrays matching IDefectSearchRequest interface exactly
			siteDepartmentIds: chipsByType.siteDepartmentIds,
			siteAssetIds: chipsByType.siteAssetIds,
			modelIds: chipsByType.modelIds,
			defectWorkOrders: chipsByType.defectWorkOrders,
			serviceWorkOrders: chipsByType.serviceWorkOrders,
			defectStatusIds: chipsByType.defectStatusIds,
			defectTypeIds: chipsByType.defectTypeIds,
			defectRiskRatingIds: chipsByType.defectRiskRatingIds,
			systemIds: chipsByType.systemIds,
			textSearches: chipsByType.textSearches,
		};
		let response = await API.post(`${Apis.DefectsSearch}`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getCountOfDefectsList = async ({
	siteAppId,
	search = "",
	fromDate = "",
	toDate = "",
	chips = [],
	onlySAPErrors = false,
	onlyFLOC = false,
}) => {
	try {
		// Process chips into individual arrays using centralized utility function
		const chipsByType = processChipsForAPI(chips);

		const payload = {
			siteAppId,
			search,
			fromDate,
			toDate,
			onlySAPErrors,
			onlyFLOC,
			// Individual arrays matching IDefectSearchRequest interface exactly
			siteDepartmentIds: chipsByType.siteDepartmentIds,
			siteAssetIds: chipsByType.siteAssetIds,
			modelIds: chipsByType.modelIds,
			defectWorkOrders: chipsByType.defectWorkOrders,
			serviceWorkOrders: chipsByType.serviceWorkOrders,
			defectStatusIds: chipsByType.defectStatusIds,
			defectTypeIds: chipsByType.defectTypeIds,
			defectRiskRatingIds: chipsByType.defectRiskRatingIds,
			systemIds: chipsByType.systemIds,
			textSearches: chipsByType.textSearches,
		};

		let response = await API.post(`${Apis.Defects}/count`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};
export const getDefectAutocompleteSearch = async ({ search = "" }) => {
	try {
		let response = await API.get(`${Apis.DefectAutocomplete}/${search}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const postNewDefect = async (payload) => {
	try {
		let response = await API.post(`${Apis.Defects}`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};
